module.exports = __webpack_public_path__ + "img/商品百科.0d52c87b.png";